import { useEffect, useMemo, useState } from 'react';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import EmissionSearch from '../../components/EmissionSearch/EmissionSearch';
import EmissionSummary from '../../components/EmissionSummary/EmissionSummary';
import { emissionApi, mapRenapoPersonToEmissionData } from '../../api/emission.api';
import { renapoApi } from '../../../interoperability/api/renapo.api';
import { toast } from 'react-hot-toast';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../../interaces/toast.ids.interface';
import { ENUM_CERTIFICATES_TYPES } from '../../../../interaces/certificates_types.interface';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import { dowloadPdf, downloadXml } from '../../../../services/helpers';
import { FaInfoCircle, FaDownload, FaFileCode, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import PdfViewerModal from '../../../reports/components/PdfViewerModal/PdfViewerModal';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { ENUM_CERTIFICATES_STATUS } from '../../interfaces/certificates.interface';
import { useReports } from '../../../reports/hooks/useReports';
import { CERTIFICATES_TYPES_TRANSLATED } from '../../../../interaces/certificates_types.interface';
import { ENUM_MODULES } from '../../../../interaces/enums/enums.interface';
import { formatCreatedAtToDate, formatCreatedAtToTime } from '../../../../services/helpers';
import styles from "../../styles/styles.module.css"
function Emissions() {
  //
  const [customerFilters, setCustomerFilters] = useState([
    {
      filter: 'rfc',
      value_filter: '',
      show: false,
    },
    {
      filter: 'certificateType',
      value_filter: '',
      show: false,
    },
  ]);
  const {
    entities,

    fetchSearch,
    setFilters,
    filters,
    //  loading,
    searchValue,
    setSearchValue,
    //onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
  } = useReports(ENUM_MODULES.EMISSIONS, customerFilters);

  const [searchData, setSearchData] = useState({
    type: '',
    option: '',
    value: '',
    type_translated: '',
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataForSummaryCard, setDataForSummaryCard] = useState({ title: '', description: '' });
  const [showTable, setShowTable] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [folioVigente, setFolioVigente] = useState('');
  const [prefix, setPrefix] = useState('');

  //
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  const handlePreview = async (item) => {
    try {
      if (!item?.folio) return;
      const certType = item.tipo || searchData.type;
      const blob = await emissionApi.downloadCertificate(item.folio, certType);
      const blobUrl = window.URL.createObjectURL(blob);
      setPdfBlobUrl(blobUrl);
      setOpenPdf(true);
    } catch (error) {
      toast.error(error.message || 'Error de red al obtener la vista previa del PDF.', {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };

  const columns = [
    {
      accessorKey: 'folio',
      header: 'FOLIO',
    },

    {
      accessorKey: 'createdAt',

      header: ({ column }) => {
        const sorted = column.getIsSorted();

        return (
          <div className="date">
            <span>FECHA EMISIÓN</span>
            <div className="date-buttons">
              {sorted !== 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(false)}
                  className="date-button"
                >
                  <FaChevronDown size={16} />
                </button>
              )}
              {sorted === 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(true)}
                  className="date-button"
                >
                  <FaChevronUp size={16} />
                </button>
              )}
            </div>
          </div>
        );
      },
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div>
            <p>{formatCreatedAtToDate(item.createdAt)}</p>
            <p>{formatCreatedAtToTime(item.createdAt)}</p>
          </div>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = (row.original.status || '').toUpperCase();

        return (
          <span
            className={`
          status-register
             ${status == ENUM_CERTIFICATES_STATUS.VIGENTE ? 'status-color-vigente' : status == ENUM_CERTIFICATES_STATUS.VENCIDO ? 'status-color-vencido' : status == ENUM_CERTIFICATES_STATUS.REVOCADO ? 'status-color-revocado' : 'status-color-default'}
        `}
          >
            {status}
          </span>
        );
      },
    },
    {
      id: 'acciones',
      header: 'ACCIONES',
      cell: ({ row }) => {
        const item = row.original;

        return (
          <div className="others-buttons-actions">
            <button
              className="btn-action-view"
              onClick={() => handlePreview(item)}
              title="Vista previa"
            >
              <FaInfoCircle className="text-lg" />
            </button>

            <button
              className="btn-action-download"
              onClick={() => handleDownload(item.folio, item.tipo)}
              title="Descargar PDF"
            >
              <FaDownload className="icon-button" />
            </button>

            <button
              className="btn-action-download"
              onClick={() => handleDownloadXml(item.folio, item.tipo)}
              title="Descargar XML"
              style={{ backgroundColor: '#27ae60' }}
            >
              <FaFileCode className="icon-button" />
            </button>
          </div>
        );
      },
    },
  ];
  const [typeCertificateSpanish, setTypeCertificateSpanish] = useState('');
  const setTextTypeCertificate = () => {
    setTypeCertificateSpanish(CERTIFICATES_TYPES_TRANSLATED[searchData.type]);

    let titleCard = 'Información consultada';
    if (searchData.type === ENUM_CERTIFICATES_TYPES.citizens)
      titleCard = 'Información del ciudadano';
    setPrefix('EUC');
    if (searchData.type === ENUM_CERTIFICATES_TYPES.business)
      titleCard = 'Información de la empresa';
    setPrefix('EMP');
    if (searchData.type === ENUM_CERTIFICATES_TYPES.properties)
      titleCard = 'Información patrimonial';
    setPrefix('PAT');

    setDataForSummaryCard({ ...dataForSummaryCard, title: titleCard });
  };
  const [rfcToSearch, setRfcToSearch] = useState(null);
  const handleSearch = async () => {
    try {
      setLoading(true);
      setSearchResult(null);
      const isCitizenCurpSearch =
        searchData.type === ENUM_CERTIFICATES_TYPES.citizens && searchData.option === 'curp';
      let response;

      if (isCitizenCurpSearch) {
        const [emissionResponse, renapoResponse] = await Promise.all([
          emissionApi.getAnyCertificate(searchData),
          renapoApi.getPersonByCurp(searchData.value.trim().toUpperCase()),
        ]);
        if (!renapoResponse?.curp) {
          throw new Error('RENAPO no devolvió datos válidos para la CURP consultada.');
        }
        response = mapRenapoPersonToEmissionData(emissionResponse, renapoResponse);
      } else {
        response = await emissionApi.getAnyCertificate(searchData);
      }

      setTextTypeCertificate();
      setSearchResult(response);
      setRfcToSearch(response.rfc || response.ownerRfc);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (searchResult) {
      setCustomerFilters([
        {
          filter: 'rfc',
          value_filter: rfcToSearch,
          show: false,
        },
        {
          filter: 'certificateType',
          value_filter: typeCertificateSpanish,
          show: false,
        },
      ]);
    }
  }, [searchResult, typeCertificateSpanish, rfcToSearch]);
  useEffect(() => {
    if (filters.length > 0) {
      fetchSearch();
      setShowTable(true);
    }
  }, [filters, customerFilters, dataFilters]);
  const [shouldClear, setShouldClear] = useState(false);
  const onClear = () => {
    setSearchValue('');
    setPageData({ page: 1, size: 10 });
    setFilters(
      dataFilters
        .filter((item) => item.show === false)
        .map((item) => ({
          filter: item.filter,
          value_filter: item.value_filter,
        }))
    );
    setDataFilters((prevFilters) =>
      prevFilters.map((item) =>
        item.show === undefined
          ? {
              ...item,
              value_filter: '',
            }
          : item
      )
    );
    setShouldClear(true);
  };
  useEffect(() => {
    if (shouldClear) {
      fetchSearch();
      setShouldClear(false);
    }
  }, [shouldClear, fetchSearch]);
  const handleShowTables = async () => {
    setShowTable(true);
  };
  const handleEmit = async () => {
    if (!searchResult) return;
    try {
      const data = { searchData, rfc: rfcToSearch, prefix };
      const response = await emissionApi.emitCertificate(data);
      if (!response.existeUnCertificadoVigente) {
        const isRealFolio = response.folio && !response.folio.endsWith('-EMITIDO');
        const fileFolio = isRealFolio ? response.folio : rfcToSearch || 'EMITIDO';
        const a = document.createElement('a');
        a.href = response.url;
        a.download = `Certificado_${searchData.type.toLocaleUpperCase()}_${fileFolio}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        // Auto-download XML after PDF — solo si el folio es real (no el placeholder por defecto)
        if (isRealFolio) {
          try {
            const xmlBlob = await emissionApi.downloadCertificateXml(
              response.id,
              searchData.type
            );
            downloadXml(xmlBlob, searchData.type, response.folio);
          } catch (e) {
            toast.error(TOAST_ERROR_IDS.ERROR_DOWNLOADING_THE_FILE, {
              id: TOAST_ERROR_IDS.ERROR_DOWNLOADING_THE_FILE,
            });
          }
        }
        toast.success('Certificado emitido con éxito.', { id: TOAST_SUCCESS_IDS.CORRECT_DOWLOAD });
        setShowTable(true);
      } else {
        setFolioVigente(response.folio);
        setShowConfirmation(true);
      }
      await fetchSearch(rfcToSearch);
    } catch (err) {
      toast.error(err.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };

  const handleCreateNewCertificate = async () => {
    try {
      const response = await emissionApi.createNewCertificate(searchData, rfcToSearch, prefix);
      const isRealFolio = response.folio && !response.folio.endsWith('-EMITIDO');
      const fileFolio = isRealFolio ? response.folio : rfcToSearch || 'EMITIDO';
      const a = document.createElement('a');
      a.href = response.url;
      a.download = `Certificado_${searchData.type.toLocaleUpperCase()}_${fileFolio}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      if (isRealFolio) {
        try {
          const xmlBlob = await emissionApi.downloadCertificateXml(response.id, searchData.type);
          downloadXml(xmlBlob, searchData.type, response.folio);
        } catch (e) {
          toast.error(TOAST_ERROR_IDS.ERROR_DOWNLOADING_THE_FILE, {
            id: TOAST_ERROR_IDS.ERROR_DOWNLOADING_THE_FILE,
          });
        }
      }
      toast.success('Certificado emitido con éxito.', { id: TOAST_SUCCESS_IDS.CORRECT_DOWLOAD });
      setShowTable(true);
      await fetchSearch(rfcToSearch);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };
  const handleDownload = async (folio, itemTipo) => {
    try {
      const type = itemTipo || searchData.type;
      const blob = await emissionApi.downloadCertificate(folio, type);
      dowloadPdf(blob, type, folio);
      toast.success(TOAST_SUCCESS_IDS.CORRECT_DOWLOAD, { id: TOAST_SUCCESS_IDS.CORRECT_DOWLOAD });
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };

  const handleDownloadXml = async (folio, itemTipo) => {
    try {
      const type = itemTipo || searchData.type;
      const xmlBlob = await emissionApi.downloadCertificateXml(folio, type);
      downloadXml(xmlBlob, type, folio);
      toast.success(TOAST_SUCCESS_IDS.CORRECT_DOWLOAD, { id: TOAST_SUCCESS_IDS.CORRECT_DOWLOAD });
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };
  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">
              Obtención de información y generación de certificados digitales.
            </p>
          </div>
        </div>

        <EmissionSearch
          searchData={searchData}
          setSearchData={setSearchData}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onSearch={handleSearch}
          loading={loading}
          setSearchResult={setSearchResult}
        />

        {searchResult && (
          <>
            <EmissionSummary
              data={searchResult}
              type={searchData.type}
              dataInformation={dataForSummaryCard}
              onEmit={handleEmit}
            />

            <>
              <div className={styles.showTableWrapper}>
                <button
                  type="button"
                  onClick={() => {
                    showTable ? setShowTable(false) : handleShowTables();
                  }}
                  className={styles.btnToggleTable}
                >
                  {showTable ? <FaEyeSlash className={styles.btnIcon}/> : <FaEye className={styles.btnIcon} />}
                  <span className={styles.btnText}>
                    {showTable
                      ? 'Ocultar historial de certificados'
                      : 'Ver historial de certificados'}
                  </span>
                </button>
              </div>
            </>
            {showTable && (
              <DataTable
                columns={columns}
                data={entities}
                searchPlaceholder={
                  'Buscar certificado ' + typeCertificateSpanish + ' de: ' + searchResult.fullName
                }
                pageSize={4}
                loading={loading}
                emptyMessage="No hay registros"
                showSearch={true}
                showPagination={true}
                onSearch={() => fetchSearch()}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                showCreate={false}
                onClear={() => onClear()}
                showFilters={true}
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                numberFilters={1}
                dataPagination={dataPagination}
                setPageData={setPageData}
                pageData={pageData}
              />
            )}
          </>
        )}

        {showConfirmation && (
          <ConfirmationMessage
            nota={'Nota:'}
            message={`Ya cuentas con un certificado ${searchData.type_translated} VIGENTE con folio: ${folioVigente}, ¿Desea continuar con la emisión de un nuevo certificado?`}
            onConfirm={() => {
              setShowConfirmation(false);
              handleCreateNewCertificate();
            }}
            onCancel={() => {
              handleDownload(folioVigente);
              handleDownloadXml(folioVigente);
              setShowConfirmation(false);
            }}
            titleButtonCancel="Descargar certificado vigente"
          />
        )}

        {openPdf && (
          <PdfViewerModal
            onClose={() => {
              setOpenPdf(false);
              if (pdfBlobUrl) {
                window.URL.revokeObjectURL(pdfBlobUrl);
                setPdfBlobUrl(null);
              }
            }}
            pdfUrl={pdfBlobUrl}
          />
        )}
      </div>
    </DashboardLayout>
  );
}
export default Emissions;
